import { render } from "./ShareHeader.vue?vue&type=template&id=52f20ee8"
import script from "./ShareHeader.vue?vue&type=script&lang=js"
export * from "./ShareHeader.vue?vue&type=script&lang=js"

import "./ShareHeader.vue?vue&type=style&index=0&id=52f20ee8&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__